<template>
	<div class="autosuggest" v-click-outside="close">

		<div
			v-if="topList"
			v-show="showList"
			class="relative"
		>

			<ul
				class="list mobile overflow-auto"
				style="bottom: 5px; max-height: 300px;"
			>

				<li
					v-for="(option, index) in filteredList"
					:style="{ backgroundColor: hover === index ? headerColor : '', borderColor: hover === index ? headerColor : '' }"
					:class="{ 'active': hover === index }"
					class="c-pointer"
					@mouseenter="hover = index"
					@mouseleave="hover = -1"
					@click="select"
				>

					<div><strong>{{ option.text }}</strong></div>

					<div><span>{{ option.description }}</span></div>

				</li>

			</ul>

		</div>

		<input
			type="text"
			class="w-100 h-100 bg-transparent"
			:placeholder="placeholder"
			@keydown.down.prevent="next"
			@keydown.up.prevent="back"
			@keydown.enter.exact.prevent="select"
			@keydown.escape.prevent="$emit('cancel')"
			@focus="showList = true, cargarLista()"
			v-model="model"
		>

		<div
			v-if="!topList"
			v-show="showList"
			class="relative"
		>

			<ul
				class="list mobile overflow-auto"
				style="top: 0; max-height: 300px;"
			>

				<li
					v-for="(option, index) in filteredList"
					:style="{ backgroundColor: hover === index ? headerColor : '', borderColor: hover === index ? headerColor : '' }"
					:class="{ 'active': hover === index }"
					class="c-pointer"
					@mouseenter="hover = index"
					@mouseleave="hover = -1"
					@click="select"
				>

					{{ option.text }}

				</li>

			</ul>

		</div>

	</div>
</template>

<script>

	export default {

		name: 'AutoSuggest',
		props: {
			placeholder: String,
			value: [String, Number],
			active: Boolean,
			getList: Function,
			options: [Array, Function],
			topList: Boolean,
			add2List: [Function, String],
			listObject: Function
		},
		data () {
			return {
				model: '',
				list: [],
				timeout: null,
				hover: -1,
				showList: false
			}
		},
		computed: {
			filteredList () {
				return this.list.filter(el => el.text.toLowerCase().indexOf(this.model.toLowerCase()) > -1)
			},
			headerColor () {
				// Obtener el color desde la variable CSS definida en el estilo
				if (typeof window !== 'undefined' && this.$el) {
					try {
						const style = getComputedStyle(this.$el)
						const color = style.getPropertyValue('--color-header').trim()
						if (color) return color
					} catch (e) {
						console.warn('No se pudo obtener el color desde CSS:', e)
					}
				}
				// Fallback al color por defecto si no se puede obtener de CSS
				return '#a98a56'
			}
		},
		watch: {
			model () {

				this.filterList()

			},
			filteredList () {

				this.hover = -1

			},
			active () {

				this.model = ''

			}
		},
		async created () {

			if (this.options) {

				if (typeof this.options === 'function') {

					this.list = [
						{
							text: 'Cargando datos',
							value: ''
						}
					]

					this.list = await this.options()

				} else this.list = this.options

			}

		},
		methods: {

			close () {

				this.showList = false

			},

			hide () {

				this.showList = false

			},

			focus () {

				this.cargarLista()

				this.$el.querySelector('input').focus()

			},

			filterList () {

				if (this.options) return

				clearTimeout(this.timeout)

				this.timeout = setTimeout(() => {

					this.cargarLista()

				}, 500)

			},

			async cargarLista () {

				if (this.options) return

				const { data } = await this.getList()

				this.list = data.map(el => this.listObject(el)).filter(el => el !== null)

			},

			next () {

				this.hover = this.hover + 1 > this.filteredList.length - 1 ? 0 : this.hover + 1

			},

			back () {

				this.hover = this.hover - 1 < 0 ? this.filteredList.length - 1 : this.hover - 1

			},

			select () {

				const linea = this.filteredList[this.hover]

				this.model = linea.text

				this.showList = false

				this.$emit('input', linea.value)

			},

			async add () {

				if (this.model === '') return

				await this.add2List({
					descripcion: this.model
				})

				return this.model

			}

		}
	}
</script>

<style lang="scss">

	.autosuggest {
		// Definir variable CSS para acceso desde JavaScript
		--color-header: #{$--color-header};

		.relative {
			position: relative;
		}

		.list {
			display: flex;
			flex-direction: column;
			padding-left: 0;
			margin-bottom: 0;
			box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
			overflow-x: hidden;
			left: 0;
			position: absolute;
			z-index: 999;
			width: 100%;

			li {
				position: relative;
				display: block;
				padding: .5rem 1rem;
				margin-bottom: -1px;
				background-color: #fff;
				border: 1px solid rgba(0, 0, 0, .125);
				font-size: .9rem;
				width: 100%;
				color: #495057;
				text-align: inherit;
				text-decoration: none;
				flex-shrink: 0;

				&:hover, &.active {
					z-index: 2;
					color: #FFF;
					background-color: $--color-header;
				}

				&:first-child {
					border-top-left-radius: .25rem;
					border-top-right-radius: .25rem;
				}

				&:last-child {
					margin-bottom: 0;
					border-bottom-right-radius: .25rem;
					border-bottom-left-radius: .25rem;
				}
			}
		}

	}

</style>
